import { createSvgComponent } from "../../icon/createSvgComponent";
import CalendarFill from "@core/__generated__/icon/figma/calendar-fill.svg";
export default createSvgComponent(CalendarFill);